import { resetTimeReportAction } from './reportTimeActions'
import { responseChangeReportDateControls } from './reportDateControlsActions'
import { clearSelectedReportsAction } from './selectedReportsActions'
import { clearSelectedCarsAction } from './selectedCarsActions'
import { clearReportDataAction } from './reportDataActions'
import { clearReportFieldsAction } from './reportFieldsActions'
import { clearUnitReportAction } from './unitReportActions'

const resetReport = () => {
  return (dispatch) => {
    dispatch(resetTimeReportAction())
    dispatch(responseChangeReportDateControls(true))
    dispatch(clearSelectedReportsAction())
    dispatch(clearSelectedCarsAction())
    dispatch(clearReportDataAction())
    dispatch(clearReportFieldsAction())
    dispatch(clearUnitReportAction())
  }
}

export {
  resetReport
}